export interface TeamsStoreState {
  showCreateTeamModal: boolean;
  setShowCreateTeamModal: (show: boolean) => void;
  createTeamFlowState: CreateTeamFlowState;
  setCreateTeamFlowState: (state: CreateTeamFlowState) => void;
  chooseTeamPlanFlowState: ChooseTeamPlanFlowState;
  setChooseTeamPlanFlowState: (state: ChooseTeamPlanFlowState) => void;
}

export enum CreateTeamFlowState {
  CreateTeam = 'CreateTeam',
  ChoosePlan = 'ChoosePlan',
  InviteMembers = 'InviteMembers',
}

export enum ChooseTeamPlanFlowState {
  ChooseTeamPlan = 'ChooseTeamPlan',
  Payment = 'Payment',
  Success = 'Success',
}
